module.exports = __webpack_public_path__ + "static/media/now-logo.360ec385.png";